import { formatDate } from 'core/utils/date'

import { type DockAvailability, type OpenDockLoadTypeSummary } from '../domain/Shipment'

export function parseTimeToMinutes(time: string): number {
  const [rawTime, period] = time.split(' ')
  let [hours, minutes] = rawTime.split(':').map(Number)
  if (period.toUpperCase() === 'PM' && hours !== 12) hours += 12
  if (period.toUpperCase() === 'AM' && hours === 12) hours = 0
  return hours * 60 + minutes
}

export function getStartTimesFromDocks(
  docks: DockAvailability[],
  selectedDockId?: string
): string[] {
  if (selectedDockId) {
    return docks.find(dock => dock.dockId === selectedDockId)?.startTimes ?? []
  }
  return Array.from(new Set(docks.flatMap(dock => dock.startTimes))).sort(
    (a, b) => parseTimeToMinutes(a) - parseTimeToMinutes(b)
  )
}

export function formatLoadType(loadType: OpenDockLoadTypeSummary): string {
  const { operation, direction, equipmentType, mode, duration } = loadType
  return [operation, direction, equipmentType, mode, `${duration}min`].join(' - ')
}

export function formatTimeRange(start: string, end: string, facilityTimezone?: string): string {
  return `${formatDate(new Date(start), 'h:mm a', facilityTimezone)} - ${formatDate(
    new Date(end),
    'h:mm a',
    facilityTimezone
  )}`
}

export function formatScheduledAt(
  appointmentDate: string,
  appointmentTime: string,
  facilityTimezone?: string
) {
  const timezone = facilityTimezone?.replace(/[-_]/g, ' ')
  return `${formatDate(
    new Date(appointmentDate),
    'EEEE, MMM d yyyy',
    facilityTimezone
  )} @ ${appointmentTime}${timezone ? ` (${timezone})` : ''}`
}
